module.exports = __webpack_public_path__ + "static/media/home-hands.6dffc6b2.svg";